// Spinner.js
import React from "react";
import classes from "./Spinner.module.scss";

const Spinner = () => {
  return (
    <div className={classes.spinnerContainer} role="status" aria-live="polite">
      <div className={classes.spinner} aria-label="Loading"></div>
    </div>
  );
};

export default Spinner;
